import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { useAuth } from "../lib/auth";
import { useFlash } from "../lib/flash";

const DOCS = [
  ["/vilkaar", "Vilkår", "legal-link-terms"],
  ["/privatliv", "Privatlivspolitik", "legal-link-privacy"],
  ["/databehandleraftale", "Databehandleraftale", "legal-link-dpa"],
  ["/sletning-af-data", "Sletning af data", "legal-link-deletion"],
];

function Row({ label, version, current, at, testid }) {
  const ok = version && version === current;
  return (
    <div className="legal-row" data-testid={testid}>
      <b>{label}</b>
      <span className={ok ? "pill ok" : "pill warn"}>
        {!version ? "Ikke accepteret" : ok ? `Accepteret ${new Date(at).toLocaleDateString("da-DK")}` : "Ny version"}
      </span>
      <small className="muted">{version ? `Version ${version}` : `Gældende version ${current}`}</small>
    </div>
  );
}

export default function LegalSettings() {
  const { store, refresh } = useAuth();
  const flash = useFlash();
  const [busy, setBusy] = useState(false);
  if (!store || store.staff || !store.legal) return null;
  const l = store.legal;
  const pending = l.terms_version !== l.current_terms || l.dpa_version !== l.current_dpa;
  const accept = async () => {
    setBusy(true);
    try {
      const r = await api.post("/legal/accept");
      flash(r.data.flash);
      refresh();
    } catch (e) {
      flash(apiError(e.response?.data?.detail), "error");
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="panel" id="aftaler" data-testid="legal-settings">
      <h2>Aftaler og data</h2>
      <div className="legal-links">
        {DOCS.map(([to, label, id]) => (
          <Link key={to} to={to} target="_blank" data-testid={id}>{label}</Link>
        ))}
      </div>
      <Row label="Vilkår" version={l.terms_version} current={l.current_terms} at={l.accepted_at} testid="legal-row-terms" />
      <Row label="Databehandleraftale" version={l.dpa_version} current={l.current_dpa} at={l.accepted_at} testid="legal-row-dpa" />
      {pending && (
        <button className="btn primary small" onClick={accept} disabled={busy} data-testid="legal-settings-accept">
          Accepter vilkår og databehandleraftale
        </button>
      )}
      <p className="muted" style={{ fontSize: 14, marginTop: 14 }} data-testid="legal-settings-contact">
        Ønsker I at lukke kontoen eller få slettet data? Skriv til <a href="mailto:info@jatakpro.dk">info@jatakpro.dk</a>
      </p>
    </section>
  );
}

export function GuideCard() {
  const { store } = useAuth();
  if (!store || store.staff) return null;
  return (
    <section className="panel" id="guide" data-testid="guide-card">
      <h2>Hjælp og support</h2>
      <p className="muted" style={{ fontSize: 14 }}>Trin-for-trin guide med skærmbilleder til alt i JaTak Pro – eller skriv til os, så hjælper vi.</p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        <a className="btn small" href="/guide/JaTak-Pro-guide.pdf" target="_blank" rel="noreferrer" data-testid="guide-download-link">
          Download brugerguiden (PDF)
        </a>
        <Link className="btn small" to="/support" data-testid="settings-support-link">Kontakt support</Link>
      </div>
    </section>
  );
}
